import {
    GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID,
    GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS,
    MERCHANT_PAYMENT_DETAIL_API_ERROR
  } from "./actionTypes"
  
  export const getMerchantPaymentDetailByTransactionProvisionSettleGuid = guid => ({
    type: GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID,
    payload: guid,
  })
  
  export const getMerchantPaymentDetailByTransactionProvisionSettleGuidSuccess = guid => ({
    type: GET_MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_SUCCESS,
    payload: guid,
  })

  export const merchantPaymentDetailApiError = error => {
    return {
      type: MERCHANT_PAYMENT_DETAIL_API_ERROR,
      payload: error,
    }
  }